import Head from "next/head";
import "Clutch/Styles/globals.scss";
import Layout from "Clutch/Layout/Layout";
import { Analytics } from "@vercel/analytics/react";
import { WSODErrorBoundary } from "UtilityComponents/ErrorBoundary";
import "intersection-observer";
import { useContext } from "react";
import { UserContext } from "Clutch/Contexts/UserContext/UserContext"

export function reportWebVitals(metric) {
  if (typeof (window) !== 'undefined') {
    window.smi_web_vitals = window.smi_web_vitals || {}
    if (metric?.name == 'FCP') {
      window.smi_web_vitals.FCP = metric.value
    }
    if (metric?.name == 'LCP') {
      window.smi_web_vitals.LCP = metric.value
    }
  }
}

function MyApp({ Component, pageProps }) {
  // todo.. elevate the parsing up one level in DS9
  const hardCodedInitialLayoutState = {
    reloadPageOnVehicleSelection: false,
    featureFlags: {
      isLogRocketEnabled: true,
      isServiceWorkerEnabled: false,
      chatWidgetAndEmailSignupDisabledPathNames: [
        "/Info/Automobile-History-Timeline",
        "/Info/Muscle-Cars-Throughout-History",
        "/Info/A-Collector's-Guide-to-Classic-Trucks",
        "/Info/Car-And-Auto-Safety-For-Teens",
        "/Info/The-Greatest-Race-Car-Drivers-of-All-Time",
        "/Info/Car-Maintenance-and-Tips-for-Beginners",
        "/item/radiator/917347",
        "/Info/Car-Care-Checklist-for-Winter-Driving",
        "/Info/All-About-Electronic-Circuits-for-Kids",
      ],
    },
    logRocketAppId: "xi3hul/speedwaymotorscom-production",
    microFrontEndHtml: "",
    headerRedesignEnabled: true,
    isAmp: false,
    services: {
      checkout: {
        url: "/graphql/checkout",
      },
      customer: {
        url: "/graphql/customer",
      },
      content: {
        url: "/graphql/content",
      },
      discovery: {
        url: "/graphql/discovery",
      },
      recommendations: {
        url: "/graphql/recommendations",
      },
      traits: {
        url: "/graphql/trait",
      },
      customerVehicles: {
        url: "/graphql/customerproject",
      },
    },
  };


  return (
    <Layout
      state={JSON.stringify(hardCodedInitialLayoutState)}
      reserveBannerSpace={pageProps.reserveBannerSpace}
      crispEnabled={pageProps.crispEnabled}
      cwvEventsEnabled={pageProps.cwvEventsEnabled}
      seoClarityEnabled={pageProps.seoClarityEnabled}
      dontAutoSendClarityInitEvent={pageProps.dontAutoSendClarityInitEvent}
    >
      <WSODErrorBoundary>
        <Head>
          {/* not for sure what's perfectly correct here */}
          <meta
            name="viewport"
            content="initial-scale=1.0, user-scalable=1, width=device-width, height=device-height"
          />
          <link rel="apple-touch-icon" href="https://content.speedwaymotors.com/BrandImages/playstore.png" />

          <link rel="apple-touch-startup-image" media="screen and (device-width: 430px) and (device-height: 932px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
            href="https://content.speedwaymotors.com/HomePageImages/iPhone_14_Pro_Max_portrait.png" />

          <link rel="apple-touch-startup-image" media="screen and (device-width: 393px) and (device-height: 852px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
            href="https://content.speedwaymotors.com/HomePageImages/iPhone_14_Pro_portrait.png" />

          <link rel="apple-touch-startup-image" media="screen and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
            href="https://content.speedwaymotors.com/HomePageImages/iPhone_14_Plus__iPhone_13_Pro_Max__iPhone_12_Pro_Max_portrait.png" />

          <link rel="apple-touch-startup-image" media="screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
            href="https://content.speedwaymotors.com/HomePageImages/iPhone_14__iPhone_13_Pro__iPhone_13__iPhone_12_Pro__iPhone_12_portrait.png" />

          <link rel="apple-touch-startup-image" media="screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
            href="https://content.speedwaymotors.com/HomePageImages/iPhone_13_mini__iPhone_12_mini__iPhone_11_Pro__iPhone_XS__iPhone_X_portrait.png" />

          <link rel="apple-touch-startup-image" media="screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
            href="https://content.speedwaymotors.com/HomePageImages/iPhone_11_Pro_Max__iPhone_XS_Max_portrait.png" />

          <link rel="apple-touch-startup-image" media="screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
            href="https://content.speedwaymotors.com/HomePageImages/iPhone_11__iPhone_XR_portrait.png" />


          <link rel="apple-touch-startup-image"
            media="screen and (device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
            href="https://content.speedwaymotors.com/HomePageImages/iPhone_8_Plus__iPhone_7_Plus__iPhone_6s_Plus__iPhone_6_Plus_portrait.png" />
          <link rel="apple-touch-startup-image"
            media="screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
            href="https://content.speedwaymotors.com/HomePageImages/iPhone_8__iPhone_7__iPhone_6s__iPhone_6__4.7__iPhone_SE_portrait.png" />

          <meta name="theme-color" content="rgb(70, 10, 102)" />
          <link rel="manifest" href="/manifest.json" />

          <style data-href="/Content/Fonts/NeuePlakV2-Regular.woff2">
            {
              "@font-face{font-family:NeuePlakTextW04-Regular, sans-serif;font-style:normal;letter-spacing:0.05em;}"
            }
          </style>

          <style data-href="/Content/Fonts/NeuePlakV2-Bold.woff2">
            {
              "@font-face{font-family:NeuePlakTextW04-Bold, sans-serif;font-style:normal;}"
            }
          </style>

          <style data-href="/Content/Fonts/NeuePlakV2-NarrowSemiBold.woff2">
            {
              "@font-face{font-family:NeuePlakW04-NarrowSemiBold, sans-serif;font-style:normal;letter-spacing:0.05em;}"
            }
          </style>
        </Head>
        <Component {...pageProps} />
        <VercelAudienceAnalytics />
      </WSODErrorBoundary>
    </Layout>
  );
}

export default MyApp;


const VercelAudienceAnalytics = () => {
  const { context: userContext } = useContext(UserContext);
  if (userContext.isBot()) {
    return false;
  }
  return <Analytics />
}